import { render } from "./StockListPage.vue?vue&type=template&id=21d01769"
import script from "./StockListPage.vue?vue&type=script&lang=js"
export * from "./StockListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__